export const LOAD_STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error'
};

export const DEFAULT_CURRENCY = 'HUF';
